import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom'

export function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let location = useLocation()
    let navigate = useNavigate()
    let params = useParams()
    return (
      <Component
        {...props}
        router={{ location, navigate, params }}
      />
    )
  }

  return ComponentWithRouterProp
}

export const ProtectedRoute = ({ isAllowed, redirectPath = '/login', children }) => {
  if (!isAllowed) {
    return (
      <Navigate
        to={redirectPath}
        replace
      />
    )
  }

  return children
}

export const ordenarMenu = (a, b) => {
  if (a.orden < b.orden) {
    return -1
  } else if (a.orden > b.orden) {
    return 1
  } else {
    return 0
  }
}

export const ordenarLista = (a, b) => {
  if (a.codigo_lista < b.codigo_lista) {
    return -1
  } else if (a.codigo_lista > b.codigo_lista) {
    return 1
  } else {
    return 0
  }
}

export const b64DecodeUnicode = str => {
  return decodeURIComponent(
    atob(str)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      })
      .join(''),
  )
}

export const validaEmail = email => {
  return email.match(
    /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i,
  )
}

export const validaPass = pass => {
  /*
  6 tamaño mínimo
  1 mayúscula mínimo
  1 minúscula mínimo
  1 número mínimo
  1 símbolo mínimo(*+-_.:,;!¡?¿$&#)
  */

  let regexp =
    /^(?=(?:[^a-z]*[a-z]){1,})(?=(?:[^A-Z]*[A-Z]){1,})(?=(?:[^0-9]*[0-9]){1,})(?=(?:.*[\*\+\-\_\.\:\,\;\!\¡\?\¿\$\&\#]){1,}).{6,}$/

  return regexp.test(pass)
}

export const obtenerValorParametro = (lista_parametros, codigo_parametro, codigo_origen) => {
  let parametros_filtrados
  let valor_esp

  if (lista_parametros && lista_parametros.length > 0) {
    //Filtramos la lista
    parametros_filtrados = lista_parametros.filter(
      parametro =>
        (parametro.modulo === codigo_origen && parametro.clave === codigo_parametro) ||
        (parametro.modulo === 'GEN' && parametro.clave === codigo_parametro),
    )

    //Si existen valores
    if (parametros_filtrados && parametros_filtrados.length > 0) {
      //Si solo existe uno lo retornamos
      if (parametros_filtrados.length === 1) {
        return parametros_filtrados[0].valor
      } else {
        //Si existen más  recorremos el array
        parametros_filtrados.forEach(function (value, index, array) {
          if (value.modulo === codigo_origen && value.clave === codigo_parametro) {
            //Seteamos el valor especifico
            valor_esp = value.valor
          }
        })
        return valor_esp
      }
    } else {
      // Si no encuentra valores retorna null
      return null
    }
  } else {
    return null
  }
}

export const cargarArrayPrecios = (p_origen, articulos_a_procesar, precios_cargados) => {
  let articulos_aux = []
  switch (p_origen) {
    default:
      // origen: articulos_a_procesar => { articulos: state.listadoArticulos.articulos,
      //                      novedades: state.listadoArticulos.novedades,
      //                      ofertas: state.listadoArticulos.ofertas,
      //                      pedido_habitual: state.listadoArticulos.pedido_habitual,
      //                      relacionados: state.listadoArticulos.relacionados
      //                      buscadorRapido: state.listadoArticulos.articulos
      //                     }
      for (let actual of articulos_a_procesar.articulos) {
        if (!precios_cargados?.[actual.codigo_articulo]?.[actual.presentacion_web]) {
          articulos_aux.push({
            codigo_articulo: actual.codigo_articulo,
            cantidad: actual.cantidad_minima ? Number(actual.cantidad_minima) : 1,
            presentacion: actual.presentacion_web,
          })
        }
      }
      break

    case 'equivalentes':
      // articulos_a_procesar => state.listadoArticulos.equivalentes
      for (let actual of articulos_a_procesar.equivalentes) {
        for (let articulo_act of actual.articulos) {
          if (!precios_cargados[articulo_act.codigo_articulo]) {
            //Solo añadimos el articulo si no está en el estado
            articulos_aux.push({
              codigo_articulo: articulo_act.codigo_articulo,
              cantidad: actual.cantidad_minima ? Number(actual.cantidad_minima) : 1,
              presentacion: articulo_act.presentacion_web,
            })
          } else if (
            !precios_cargados?.[articulo_act.codigo_articulo]?.[articulo_act.presentacion_web]
          ) {
            // Si la presentacion buscada no está en el estado de precios
            articulos_aux.push({
              codigo_articulo: articulo_act.codigo_articulo,
              cantidad: articulo_act.cantidad_minima ? Number(articulo_act.cantidad_minima) : 1,
              presentacion: articulo_act.presentacion_web,
            })
          }
        }
      }

      break

    case 'listasCompra':
    case 'pedidos_anteriores':
    case 'pedidos_pendientes':
    case 'resumen':
      // origen: articulos_a_procesar => { listas_compra: state.listasCompra.lineas_lista_detalle
      //                                   pedidos_anteriores: state.pedidosAnteriores.lineas_pedido_anterior_detalle
      //                                   pedidos_pendientes: state.pedidosPendientes.lineas_pedido_pendiente_detalle
      //                                   resumen: state.pedido.lineas (filtradas sin regalos)
      //                                 }

      for (let actual of articulos_a_procesar) {
        if (
          !precios_cargados?.[actual.articulo]?.[
            actual.presentacion_pedido || actual.presentacion_web
          ] ||
          parseFloat(
            precios_cargados[actual.articulo][actual.presentacion_pedido || actual.presentacion_web]
              .cantidad_precio,
          ).toFixed(4) !== parseFloat(actual.cantidad_pedida).toFixed(4)
        ) {
          // Si la presentacion buscada no está en el estado de precios
          let articulo = {
            codigo_articulo: actual.articulo,
            cantidad: actual.cantidad_pedida ? parseFloat(actual.cantidad_pedida).toFixed(4) : 1,
            presentacion: actual.presentacion_pedido || actual.presentacion_web,
          }
          articulos_aux.push(articulo)
        }
      }
      break
    case 'plantillas':
      for (let actual of articulos_a_procesar) {
        if (
          !precios_cargados?.[actual.articulo]?.[actual.presentacion_web] ||
          parseFloat(
            precios_cargados[actual.articulo][actual.presentacion_web].cantidad_precio,
          ).toFixed(4) !== parseFloat(actual.cantidad_minima || 1).toFixed(4)
        ) {
          // Si la presentacion buscada no está en el estado de precios
          let articulo = {
            codigo_articulo: actual.codigo_articulo,
            cantidad: actual.cantidad_minima ? parseFloat(actual.cantidad_minima).toFixed(4) : 1,
            presentacion: actual.presentacion_web,
          }
          articulos_aux.push(articulo)
        }
      }
      break
    case 'sustitutos':
      articulos_a_procesar.sustitutos ??= []
      // articulos_a_procesar => state.listadoArticulos.sustitutos
      for (let actual of articulos_a_procesar.sustitutos) {
        if (actual?.articulos?.length > 0) {
          for (let articulo_act of actual.articulos) {
            if (
              !precios_cargados?.[articulo_act.codigo_articulo]?.[articulo_act.presentacion_web]
            ) {
              // Si la presentacion buscada no está en el estado de precios
              articulos_aux.push({
                codigo_articulo: articulo_act.codigo_articulo,
                cantidad: articulo_act.cantidad_minima ? Number(articulo_act.cantidad_minima) : 1,
                presentacion: articulo_act.presentacion_web,
              })
            }
          }
        }
      }
      break
  }
  return articulos_aux
}

export const cargarArrayStocks = (p_origen, articulos_a_procesar, stocks_cargados, pedido) => {
  let articulos_aux = []
  switch (p_origen) {
    default:
      // origen: articulos_a_procesar => { articulos: state.listadoArticulos.articulos,
      //                      novedades: state.listadoArticulos.novedades,
      //                      ofertas: state.listadoArticulos.ofertas,
      //                      pedido_habitual: state.listadoArticulos.pedido_habitual,
      //                      relacionados: state.listadoArticulos.relacionados
      //                      buscadorRapido: state.listadoArticulos.articulos
      //                     }
      // pedido => state.pedidos.pedido
      for (let actual of articulos_a_procesar.articulos) {
        if (!stocks_cargados?.[actual.codigo_articulo]?.[actual.presentacion_web]?.['']?.stock) {
          //Solo añadimos el articulo si no está en el estado
          articulos_aux.push({
            codigo_articulo: actual.codigo_articulo,
            presentacion: actual.presentacion_web,
            codigo_almacen: pedido.almacen,
            situacion: '',
          })
        }
      }
      break
    case 'equivalentes':
      // articulos_a_procesar => state.listadoArticulos.equivalentes
      // pedido => state.pedidos.pedido

      for (let actual of articulos_a_procesar.equivalentes) {
        for (let articulo_act of actual.articulos) {
          if (!stocks_cargados?.[actual.codigo_articulo]?.[actual.presentacion_web]?.['']?.stock) {
            //Solo añadimos el articulo si no está en el estado
            articulos_aux.push({
              codigo_articulo: articulo_act.codigo_articulo,
              presentacion: articulo_act.presentacion_web,
              codigo_almacen: pedido.almacen,
              situacion: '',
            })
          }
        }
      }
      break
    case 'listasCompra':
    case 'pedidos_anteriores':
    case 'pedidos_pendientes':
    case 'plantillas':
      // origen: articulos_a_procesar => { listasCompra: state.listasCompra.lineas_lista_detalle
      //                     pedidos_anteriores: state.pedidosAnteriores.lineas_pedido_anterior_detalle
      //                     pedidos_pendientes: state.pedidosPendientes.lineas_pedido_pendiente_detalle
      //                    }
      // pedido => state.pedidos.pedido/state.pedidosPendientes.pedidos_pendientes[pedido_pendiente_detalle(index)]
      for (let actual of articulos_a_procesar) {
        if (
          !stocks_cargados?.[actual.codigo_articulo]?.[
            actual.presentacion_pedido || actual.presentacion_web
          ]?.['']?.stock
        ) {
          // Si la presentacion buscada no está en el estado de precios

          articulos_aux.push({
            codigo_articulo: actual.articulo || actual.codigo_articulo,
            presentacion: actual.presentacion_pedido || actual.presentacion_web,
            codigo_almacen: pedido.almacen,
            situacion: '',
          })
        }
      }
      break

    case 'sustitutos':
      articulos_a_procesar.sustitutos ??= []
      // articulos_a_procesar => state.listadoArticulos.equivalentes
      // pedido => state.pedidos.pedido

      for (let actual of articulos_a_procesar.sustitutos) {
        if (actual?.articulos?.length > 0) {
          for (let articulo_act of actual.articulos) {
            if (
              !stocks_cargados?.[articulo_act.codigo_articulo]?.[articulo_act.presentacion_web]?.[
                ''
              ]?.stock
            ) {
              // Solo añadimos el articulo si no está en el estado
              articulos_aux.push({
                codigo_articulo: articulo_act.codigo_articulo,
                presentacion: articulo_act.presentacion_web,
                codigo_almacen: pedido.almacen,
                situacion: '',
              })
            }
          }
        }
      }
  }
  return articulos_aux
}

export const cargarParametros = (p_parametros, p_lista_parametros, p_origen) => {
  let v_parametros = {}
  for (let parametro in p_parametros) {
    switch (p_parametros[parametro]) {
      case 'andr_a':
        v_parametros.andr_a = obtenerValorParametro(p_lista_parametros, 'ANDR_A', p_origen)
        break
      case 'andr_desc':
        v_parametros.andr_desc = obtenerValorParametro(p_lista_parametros, 'ANDR_DESC', p_origen)
        break
      case 'btn_presup':
        v_parametros.btn_presup = obtenerValorParametro(p_lista_parametros, 'BTN_PRESUP', p_origen)
        break
      case 'btn_subs':
        v_parametros.btn_subs = obtenerValorParametro(p_lista_parametros, 'BTN_SUBS', p_origen)
        break
      case 'bus_avanz':
        v_parametros.bus_avanz = obtenerValorParametro(p_lista_parametros, 'BUS_AVANZ', p_origen)
        break
      case 'busc_rapido':
        v_parametros.busc_rapido = obtenerValorParametro(
          p_lista_parametros,
          'BUSC_RAPIDO',
          p_origen,
        )
        break
      case 'ej_onblur':
        v_parametros.ej_onblur = obtenerValorParametro(p_lista_parametros, 'EJ_ONBLUR', p_origen)
        break
      case 'img_cargadas':
        v_parametros.img_cargadas = obtenerValorParametro(
          p_lista_parametros,
          'IMG_CARGADAS',
          p_origen,
        )
        break
      case 'maxim_agrup':
        v_parametros.maxim_agrup = obtenerValorParametro(
          p_lista_parametros,
          'MAXIM_AGRUP',
          p_origen,
        )
        break
      case 'mostrar_iva':
        v_parametros.mostrar_iva = obtenerValorParametro(
          p_lista_parametros,
          'MOSTRAR_IVA',
          p_origen,
        )
        break
      case 'msg_tar_env':
        v_parametros.msg_tar_env = obtenerValorParametro(
          p_lista_parametros,
          'MSG_TAR_ENV',
          p_origen,
        )
        break
      case 'tipo_msg_tar_env':
        v_parametros.tipo_msg_tar_env = obtenerValorParametro(
          p_lista_parametros,
          'TIPO_MSG_TAR_ENV',
          p_origen,
        )
        break
      case 'tipo_precio':
        v_parametros.tipo_precio = obtenerValorParametro(
          p_lista_parametros,
          'TIPO_PRECIO',
          p_origen,
        )
        break
      case 'stock_cantidad':
        v_parametros.stock_cantidad = obtenerValorParametro(
          p_lista_parametros,
          'STOCK_CANTIDAD',
          p_origen,
        )
        break
      case 'def_input':
        v_parametros.def_input = obtenerValorParametro(p_lista_parametros, 'DEF_INPUT', p_origen)
        break
      case 'cant_def':
        v_parametros.cant_def = obtenerValorParametro(p_lista_parametros, 'CANT_DEF', p_origen)
        break
      case 'resumen_simple':
        v_parametros.resumen_simple = obtenerValorParametro(
          p_lista_parametros,
          'RESUMEN_SIMPLE',
          p_origen,
        )
        break
      case 'mostrar_pres':
        v_parametros.mostrar_pres = obtenerValorParametro(
          p_lista_parametros,
          'MOSTRAR_PRES',
          p_origen,
        )
        break
      case 'estilo_precio':
        v_parametros.estilo_precio = obtenerValorParametro(
          p_lista_parametros,
          'ESTILO_PRECIO',
          p_origen,
        )
        break
      case 'mostrar_des_pres':
        v_parametros.mostrar_des_pres = obtenerValorParametro(
          p_lista_parametros,
          'MOSTRAR_DES_PRES',
          p_origen,
        )
        break
      default:
        break
    }
  }
  return v_parametros
}

export function dynamicSort(property) {
  var sortOrder = 1
  if (property[0] === '-') {
    sortOrder = -1
    property = property.substr(1)
  }
  return function (a, b) {
    /* next line works with strings and numbers,
     * and you may want to customize it to your needs
     */
    var result = a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0
    return result * sortOrder
  }
}

export function programaActivo(menus, programa) {
  return menus.some(
    menu =>
      menu.programa === programa ||
      (menu.hijos && menu.hijos.length > 0 && menu.hijos.some(hijo => hijo.programa === programa)),
  )
}

export function descargarFichero(nombre, fichero, extension = '') {
  const binary = atob(fichero.replace(/\s/g, ''))
  const len = binary.length
  const buffer = new ArrayBuffer(len)
  const view = new Uint8Array(buffer)

  for (let i = 0; i < len; i += 1) {
    view[i] = binary.charCodeAt(i)
  }
  // create the blob object with content-type "application/pdf"
  const blob = new Blob([view], { type: 'application/octet-stream' })
  const url = URL.createObjectURL(blob)

  const a = document.createElement('a')
  document.body.appendChild(a)
  a.style = 'display: none'
  a.href = url
  a.download = nombre

  a.click()
}

/**
 * Función para comprobar si un valor es undefined, null o "" y
 * quitar tantas comprobaciones de los return de componentes y vistas
 */
export function isValidValue(prop) {
  return prop !== undefined && prop !== null && prop !== ''
}
